import URI from 'urijs';
import moment from 'moment';

class Filters {
  static watchFilters(loadFunction) {
    Filters.toggleIndicatorTypeCheckboxColors("incident_type", "private_actors")

    $('.js-date-range-selector').click(function(event) {
      let selector = $(event.target)
      var startDate = moment(); 
      var endDate = moment(); 
      if(selector.data('range') == "past-30-days") {
        startDate = moment().subtract(30, 'days');
      } else if(selector.data('range') == "past-90-days") {
        startDate = moment().subtract(90, 'days');
      } else if(selector.data('range') == "past-365-days") {
        startDate = moment().subtract(365, 'days');
      } else if(selector.data('range') == "year-to-date") {
        startDate = moment().startOf('year');
      } else if(selector.data('range') == "previous-year") {
        let year = moment().year() - 1;
        startDate = moment().year(year).startOf('year');
        endDate = moment().year(year).endOf('year');
      } else if(selector.data('range') == "previous-quarter") {
        let quarter = moment().quarter() - 1;
        startDate = moment().quarter(quarter).startOf('quarter');
        endDate = moment().quarter(quarter).endOf('quarter');
      } else if(selector.data('range') == "previous-month") {
        startDate = moment().subtract(1, 'months').startOf('month');
        endDate = moment().subtract(1, 'months').endOf('month');
      }
      
      $('.js-datepicker-start-date-calendar').datepicker('setDate', startDate.toDate()); 
      $('.js-datepicker-end-date-calendar').datepicker('setDate', endDate.toDate());
      event.stopPropagation();
    })

    $('.js-filter-toggle-mobile').click(function() {
      $('.js-filter-container').show()
    })

    $('.js-close-filters').click(function() {
      $('.js-filter-container').hide()
    })

    $('.js-record-type-filter-option').click((event) => {
      Filters.switchRecordType(event.target)
      loadFunction();
    })

    $('.js-display-type-button').click(function(event) {
      Filters.switchDisplayType(event.target);
      loadFunction();
    })

    $('.js-datepicker-start-date-calendar').datepicker({
        format: 'mm/dd/yyyy'
    });

    $('.js-datepicker-end-date-calendar').datepicker({
        format: 'mm/dd/yyyy'
    });

    $('.js-datepicker-start-date-calendar').datepicker('setDate', new Date($('.js-datepicker-start-date').val() + "T00:00:00")); 
    $('.js-datepicker-end-date-calendar').datepicker('setDate', new Date($('.js-datepicker-end-date').val() + "T00:00:00"));

    Filters.bindOnStartDateChange() 
    Filters.bindOnEndDateChange() 

    $('.js-datepicker-start-date').on('input',function(element){
      $('.js-datepicker-start-date-calendar').unbind()
      $('.js-datepicker-start-date-calendar').datepicker('setDate', new Date(element.target.value + "T00:00:00"));  
      Filters.bindOnStartDateChange() 
    })

    $('.js-datepicker-end-date').on('input',function(element){
      $('.js-datepicker-end-date-calendar').unbind()
      $('.js-datepicker-end-date-calendar').datepicker('setDate', new Date(element.target.value + "T00:00:00"));  
      Filters.bindOnEndDateChange() 
    })

    $('.js-filter-apply').click((element) => {
      loadFunction();
    });

    $('.js-filter-checkmark-clear').click((element) => {
      $(element.target).closest('.dropdown-menu').find('input:checkbox').each(function(index, e) {
        $(e).prop('checked', false);
      })
      loadFunction();
    });

    $('.js-filter-keyword-clear').click((element) => {
      $(element.target).closest('.dropdown-menu').find('input').each(function(index, e) {
        $(e).val("")
      })
      loadFunction();
    });

    $('.js-filter-radius-clear').click((element) => {
      $('#community_id').val(null).trigger('change');
      loadFunction();
    });

    $('.js-more-filters-apply').click(function(e) {
      $('.js-more-filters').find('.js-more-filter-option').each(function(index, element) {
        let dynamicFilter = $('.js-dynamic-filter[data-filter-param-key="' + $(element).data('optionValue') + '"]');

        if ($(element).is(':checked')) {
          dynamicFilter.data('filterDisplayable', true);
        } else {
          dynamicFilter.data('filterDisplayable', false);
        }

      })
      loadFunction();
    });

    function communityFormatResult(community) {
      return community.name;
    };

    function communityFormatSelection(community) {
      if (community.communities) {
        return community.communities.name;
      } else if (community.name) {
        return community.name;
      } else {
        return community.text
      }
    };

    $("#community_id").select2({
      placeholder: "Select a community",
      allowClear: true,
      dropdownParent: $('.js-filter-community-dropdown-menu'),
      minimumInputLength: 1,
      ajax: {
          url: "/communities.json",
          data: function (term, page) {
            return {
              search: term.term,
            };
          },
          processResults: function (data, page) {
            return {results: data.records};
          }
      },
      templateResult: communityFormatResult,
      templateSelection: communityFormatSelection,
    });

    $("#community_id").change((event) => {
      Filters.evaluateRadiusEnabled()
    })

    Filters.evaluateRadiusEnabled()

    $('#js-filter-radius-option').on("change", () => {
      $('.js-radius-label').text($('#js-filter-radius-option').val() + "km")
    });

    $(".select2-container").on("click", function(e) {
      e.stopPropagation();
    });
  }

  static evaluateRadiusEnabled() {
    if ($('.js-filter-community-id-option').val()) {
      document.getElementById("js-filter-radius-option").disabled = false;
      $('.disable-mask').hide()
    } else {
      document.getElementById("js-filter-radius-option").disabled = true;
      $('.disable-mask').show()
    }
  }

  static switchRecordType(target) {
    let recordType = $(target).data("recordtype");
    $('#js-record-metrics-container').hide();
    $('#js-record-list-container').show();
    if (recordType === "incidents") {
      $('.js-chart-toggle').show();
    } else {
      $('.js-chart-toggle').hide();
    }
    document.getElementById('js-record-type').dataset.recordType = recordType;
    $('.js-record-type-filter-option').removeClass('active');
    $(target).addClass('active');
    $(target).closest('.js-dynamic-filter').find('.js-filter-control-description').text($(target).text())
  }

  static switchDisplayType(target) {
    let displayType = $(target).data("displaytype");
    document.getElementById('js-display-type').dataset.displayType = displayType;
    if (displayType === "incident_type") {
      Filters.toggleIndicatorTypeCheckboxColors("incident_type", "private_actors")
    } else if (displayType === "actor") {
      Filters.toggleIndicatorTypeCheckboxColors("private_actors", "incident_type")
    } 
    $('.js-display-type-button').removeClass('selected');
    $(target).addClass('selected');
    $(target).closest('.js-dynamic-filter').find('.js-filter-control-description').text($(target).text())
  }

  static toggleIndicatorTypeCheckboxColors(toggleOn, toggleOff) {
    $('.js-dynamic-filter[data-filter-param-key="' + toggleOn + '"]').find(".js-filter-option").each(function(index, element) {
      var checkboxClass = element.dataset.checkboxClass
      $(element).siblings(".state").addClass(checkboxClass)
    })
    $('.js-dynamic-filter[data-filter-param-key="' + toggleOff + '"]').find(".js-filter-option").each(function(index, element) {
      var checkboxClass = element.dataset.checkboxClass
      $(element).siblings(".state").removeClass(checkboxClass)
    })
  }

  static loadFiltersByRecordType() {
    let recordType = document.getElementById('js-record-type').dataset.recordType;
    let recordTypeLabel = $('.js-record-type-filter-option[data-recordType="' + recordType + '"]').text();
    $('.js-record-type-dropdown').closest('.js-dynamic-filter').find('.js-filter-control-description').text(recordTypeLabel)
    $('.js-dynamic-filter').each((index, element) => {
      if ($(element).data('filterRecordTypes') && $(element).data('filterRecordTypes').includes(recordType) && $(element).data('filterDisplayable')) {
        $(element).show();
      } else {
        $(element).hide();
      }
    });
    Filters.resizeRecordContainer();
  }

  static watchGroupedCheckboxes() {
    $("input[type='checkbox']").change(function () {
      if($(this).hasClass('parent-checkbox')) {
        $(this).closest('.checkbox-container')
               .find('.children-checkboxes')
               .find("input[type='checkbox']")
               .prop('checked', this.checked);
      } else {
       if ($(this).closest('.children-checkboxes').find("input:checkbox:not(:checked)").length) {
          $(this).closest('.checkbox-container').find('.parent-checkbox').prop('checked', false);
        } else {
          $(this).closest('.checkbox-container').find('.parent-checkbox').prop('checked', true);
        }
      }
    });
  }


  static bindOnStartDateChange() {
    $('.js-datepicker-start-date-calendar').datepicker().on('changeDate', function (event) {
      let target = $(event.target)
      target.closest('.start-date-cell').find('.js-datepicker-start-date').val(moment(target.datepicker('getDate')).format("YYYY-MM-DD"))
    });
  }

  static bindOnEndDateChange() {
    $('.js-datepicker-end-date-calendar').datepicker().on('changeDate', function (event) {
      let target = $(event.target)
      target.closest('.end-date-cell').find('.js-datepicker-end-date').val(moment(target.datepicker('getDate')).format("YYYY-MM-DD"))
    });
  }

  static parseFilters() {
    var uri = new URI(window.location.href)
    var params = uri.query(true)
    // Signed-in users get the private_actors filter instead of primary_actors, so apply
    // public-actor deep links to it rather than silently dropping the actor.
    if (params.primary_actors && !$(".js-dynamic-filter[data-filter-param-key='primary_actors']").length) {
      params.private_actors = params.private_actors || params.primary_actors;
      delete params.primary_actors;
    }
    for (const key in params) {
      $(".js-dynamic-filter[data-filter-param-key='" + key + "']").data('filterDisplayable', true);
      $(".js-more-filter-option[data-option-value='" + key + "']").prop('checked', true);

      let values = params[key];
      if (key == "start_date" || key == "end_date") {
        $(".js-datepicker-" + key.replace("_", "-")).val(values)
      } else if (key == "keyword") {
        $(".js-filter-keyword").val(values)
      } else if (key == "community_id" || key == "search_radius") {
        let option = new Option(params["community_name"], params["community_id"], true, true);
        $("#community_id").append(option);
        $("#community_id").trigger('change');
        $("#js-filter-radius-option").val(params["search_radius"]);
        $('.js-radius-label').text(params["search_radius"] + "km")
      } else if (key == "country") {
        let countries = Array.isArray(values) ? values : values.split(",");
        let regionFilter = $(".js-dynamic-filter[data-filter-param-key='region']");
        regionFilter.data('filterDisplayable', true);
        $(".js-more-filter-option[data-option-value='region']").prop('checked', true);
        countries.forEach(function(country) {
          regionFilter.find('.parent-checkbox').each(function() {
            if ($(this).closest('.checkbox-container').find('label').first().text().trim() === country.trim()) {
              $(this).prop('checked', true);
              $(this).closest('.checkbox-container').find('.children-checkboxes input:checkbox').prop('checked', true);
            }
          });
        });
      } else if (key == "explosives" && values == "true") {
        $('#js-explosives-filter').prop('checked', true);
      } else if (key == "record_type") {
        Filters.switchRecordType($(".js-record-type-filter-option[data-recordtype='" + values + "']"))
      } else if (key == "display_type") {
        Filters.switchDisplayType($(".js-display-type-button[data-displaytype='" + values + "']"))
      } else {
        let valuesArray = Array.isArray(values) ? values : values.split(",");
        for (var index in valuesArray) {
          if (valuesArray[index] === 'violence_against_civilians') {
            let container = $(".js-dynamic-filter[data-filter-param-key='incident_type']")
              .find('.parent-checkbox').first().closest('.checkbox-container');
            container.find('.parent-checkbox').prop('checked', true);
            container.find('.children-checkboxes input:checkbox').prop('checked', true);
          } else {
            $(".js-dynamic-filter[data-filter-param-key='" + key + "']")
            .find(".js-filter-option[data-option-value='" + valuesArray[index] + "']")
            .prop('checked', true);
          }
        }
      }
    }
    $('.checkbox-container').each(function() {
      let children = $(this).find('.children-checkboxes input:checkbox');
      if (children.length && !children.filter(':not(:checked)').length) {
        $(this).find('.parent-checkbox').prop('checked', true);
      }
    });
  }

  static resizeRecordContainer() {
    var mapHeight = $("#map").height();
    var offset = $('.js-filter-container').height()
    $('#js-record-list-container').height(mapHeight - offset - 30)
  }
}

export default Filters;
